import SocialMediaContainer from "../../../components/Auth/SocialMediaContainer"
import OrContainer from "../../../components/Auth/OrContainer"
import AuthForm from "../../../components/Auth/AuthForm"
import URLS from "../../../config/navigation"
import React, { useEffect, useRef, useState } from "react"
import TermsPolicyRow from "../../../components/Auth/TermsPolicyRow"
import { register } from "../../../store/entities/Auth/Auth.actions"
import { getSelfProfileInfo } from "../../../store/entities/Profile/Profile.actions"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { selectIsLoggedIn } from "../../../store/selectors/Auth"
import { selectProfileInfo } from "../../../store/selectors/Profile"
import HelmetComponent from "../../../components/Common/Helmet"
import TitleComponent from "../../../components/Auth/TitleContainer"
import { getToken } from "../../../utils/tokenUttils"
import * as TYPES from "../../../store/entities/Profile/Profile.types"
import queryString from "query-string"

const SignUp = (props) => {
  const [referrer, setReferrer] = useState(null)
  const [loading, setLoading] = useState(false)
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const profileInfo = useSelector(selectProfileInfo)
  const dispatch = useDispatch()
  const history = useHistory()
  const privacyUrlRef = useRef("https://teachon.org/privacy")
  const termsUrlRef = useRef("https://teachon.org/terms")


  const getSelfCallback = (response) => {
    if (!response.firstName || !response.secondName || !response.about) {
      localStorage.setItem("onBoarding", true)
      history.push(URLS.PUBLIC.SETUP)
    } else if (!response.publicUrlName) {
      localStorage.setItem("onBoarding", true)
      history.push(URLS.PUBLIC.LINK)
    } else if (!response.stripeAccountId) {
      localStorage.setItem("onBoarding", true)
      history.push(URLS.PUBLIC.PREVIEW_CONNECT_BANK_ACC)
    } else {
      if (response.stripeOnboardingLink) {
        window.location.href = response.stripeOnboardingLink
      }
    }
  }

  useEffect(() => {
    dispatch({ type: TYPES.ON_LOGOUT })
  }, [])

  useEffect(async () => {
    setLoading(true)
    if (loading == false && getToken()) {
      getSelfCallback(profileInfo)
    } else {
      setLoading(false)
    }
  }, [isLoggedIn, profileInfo, loading])

  useEffect(()=>{
    const { ref } = queryString.parse(props.location.search)
    setReferrer(ref)
  })

  const handleSubmitSignUp = async (values, { setSubmitting }) => {
    values.referrer = referrer
    await dispatch(register({ ...values })).then((res) => {
      console.log("Redirect to setup")
      history.push(URLS.PROFILE.SETUP)
    })
  }

  return (
    <div className={"container"}>
      <HelmetComponent title="Sign Up For Free - TeachOn" />
      <TitleComponent title={" Create your TeachOn Account"} />

      <div className={"formContainer"}>
        {/* <SocialMediaContainer />
        <OrContainer />  */}
        <AuthForm
          handleSubmit={handleSubmitSignUp}
          submitText={"Sign Up for Free"}
        >
          <TermsPolicyRow
            privacyUrlRef={privacyUrlRef}
            termsUrlRef={termsUrlRef}
          />
        </AuthForm>
        <span className={"haveAcc BODY_MEDIUM"}>
          Already have an account?{" "}
          <a className={"techOnlink BODY_MEDIUM"} href={URLS.AUTH.SIGNIN}>
            Log In
          </a>
        </span>
      </div>
    </div>
  )
}

export default SignUp
